<footer class="fw-full bg-blue-950 py-8" data-testid="footer-section">
  <div class="flex flex-col items-center w-full sm:max-w-7xl mx-auto text-3xl p-4 sm:pt-4 h-full">
    <div class="flex flex-col justify-center items-center w-full">
      <img src="assets/navigandi-logo-white.png" alt="Logo da empresa" class="w-32 h-auto" />
      <span class="text-base text-slate-200">Tecnologia 100% nacional para mares globais.</span>
    </div>

    <div class="flex flex-row items-center justify-center">
      <div class="flex flex-row justify-center items-baseline w-full mt-4">
        <span class="flex text-sm text-slate-400"
          >Rua Cerro Corá, 1306, Conjunto 14 - Vila Romana – São Paulo – SP – 05061-200</span
        >
        <a href="https://www.linkedin.com/company/naviganditech/" target="_blank">
          <i class="fa-brands fa-linkedin-in text-slate-400 text-2xl ml-4 mr-4"></i>
        </a>
        <a href="https://www.instagram.com/navigandi_tech/" target="_blank">
          <i class="fa-brands fa-instagram text-slate-400 text-2xl mr-4"></i>
        </a>
      </div>
    </div>
  </div>
  <div class="flex flex-col justify-center items-center w-full">
    <p class="text-sm text-slate-400 text-center mt-4">
      © 2025 Navigandi Pesquisas e Desenvolvimento de Equipamentos Marítimos Ltda - CNPJ:
      33.448.603/0001-00
    </p>
    <a href="privacy-policy" class="text-sm text-slate-400 text-center mt-4">
      Política de Privacidade
    </a>
    <p class="text-sm text-slate-400 text-center mt-4">Todos os direitos reservados</p>
  </div>
</footer>
